import React from 'react';

import './Users.css';
import { FcGoogle } from "react-icons/fc";
import { UsersLogic } from './UsersLogic';
import { GoLaw } from 'react-icons/go';


const Users = () => {
    const { users, accessLevelList, handleConfirmUser, handleApproveUser, handleToggleEmployeeActive, handleAccessLevelChange
    } = UsersLogic()
    return (
        <div className="main-content">
            {/* <div className=""> */}

            <div className="p-3 mb-0 mt-1 custom-bg-white rounded d-flex justify-content-between align-items-center">
                <span className="m-0 title">Users</span>
            </div>

            <div className=" mt-4">
                <div className='table-content-user'>
                    <table className="table table-bordered">
                        <thead className="thead-dark">
                            <tr>
                                <th>Email</th>
                                <th>Actions</th>
                                <th>Access Level</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user) => {
                                const getAttr = (name) => user.Attributes.find(attr => attr.Name === name)?.Value;
                                const empInfoStr = getAttr('custom:empInfo');

                                let accessLevel = '';
                                let isEmployeeApproved = false;
                                let isEmployeeActive = false;

                                try {
                                    const empInfo = empInfoStr ? JSON.parse(empInfoStr) : {};
                                    accessLevel = empInfo.accessLevel?.toString() || '1';
                                    isEmployeeApproved = empInfo.isEmployeeApproved;
                                    isEmployeeActive = empInfo.isEmployeeActive;
                                } catch (err) {
                                    console.error('Invalid empInfo JSON:', err);
                                }

                                return (
                                    <tr key={user.Username}>
                                        <td className="align-middle user-email">
                                            {user.UserStatus === "EXTERNAL_PROVIDER" && (
                                                <span style={{ marginRight: '6px', fontSize: "16px" }}>
                                                    <FcGoogle />
                                                </span>
                                            )}

                                            {accessLevel === '1' && (
                                                <span style={{ marginRight: '6px',color:"var(--buttonColor)", fontSize: "20px" }}>
                                                    <GoLaw />
                                                </span>
                                            )}

                                            {getAttr('email')}
                                        </td>

                                        <td className="align-middle">
                                            {user.UserStatus === 'UNCONFIRMED' ? (
                                                <button
                                                    className="btn btn-primary user-action-btn"
                                                    onClick={() => handleConfirmUser(user.Username)}
                                                >
                                                    Confirmed User
                                                </button>
                                            ) : (
                                                !isEmployeeApproved ? (
                                                    <button
                                                        className="btn btn-primary user-action-btn"
                                                        onClick={() => handleApproveUser(user.Username)}
                                                    >
                                                        Approve User
                                                    </button>
                                                ) : isEmployeeActive ? (
                                                    <button
                                                        className="btn btn-danger user-action-btn"
                                                        onClick={() => handleToggleEmployeeActive(user.Username, false)}
                                                    >
                                                        Disable User
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="btn btn-info user-action-btn"
                                                        onClick={() => handleToggleEmployeeActive(user.Username, true)}
                                                    >
                                                        Activate User
                                                    </button>
                                                )
                                            )}
                                        </td>

                                        <td className="align-middle">
                                            <div className="d-flex justify-content-center align-items-center h-100">
                                                <select
                                                    value={accessLevel}
                                                    onChange={(e) => handleAccessLevelChange(user.Username, e.target.value)}
                                                    className="form-select user-select"
                                                >
                                                    <option value="0" hidden>Select</option>
                                                    {accessLevelList.map((level) => (
                                                        <option key={level.value} value={level.value}>
                                                            {level.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                </div>
            </div>


        </div>
    );
};

export default Users;
